/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_FaintInputs */

const en_ui_track_intensity_faint = /** @type {(inputs: Ui_Track_Intensity_FaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faint`)
};

const de_ui_track_intensity_faint = /** @type {(inputs: Ui_Track_Intensity_FaintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwach`)
};

/**
* | output |
* | --- |
* | "Faint" |
*
* @param {Ui_Track_Intensity_FaintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_faint = /** @type {((inputs?: Ui_Track_Intensity_FaintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_FaintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_faint(inputs)
	return de_ui_track_intensity_faint(inputs)
});